import React from 'react';
import { ActivityIcon } from 'lucide-react';
import { useTimelineContext } from '../context/TimelineContext';

export const TimelineEmptyState: React.FC = () => {
  const { filters, config } = useTimelineContext();

  const hasActiveFilters = Object.values(filters).some(Boolean);
  const activeFilterNames = Object.keys(filters)
    .filter((key) => {
      const filterKey = key as keyof typeof filters;
      return filters[filterKey] && config.availableFilters.includes(filterKey);
    })
    .join(", ");

  return (
    <div className="flex min-h-[200px] flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border/70 bg-muted/30 mx-6 px-6 py-10 text-center">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted/60 text-muted-foreground">
        <ActivityIcon className="h-5 w-5" />
      </div>
      <p className="text-sm font-medium text-foreground">No timeline entries</p>
      <p className="text-xs text-muted-foreground">
      {hasActiveFilters
          ? `There's no activity for ${activeFilterNames}.`
          : "No activity recorded for this record yet."}
      </p>
    </div>
  );
};
